import React, { useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import enIcon from '../assets/img/flags/lang-en.png';
import heIcon from '../assets/img/flags/lang-he.png';

import { setLanguageId, setUiLanguageId } from '../redux/actions/baseActions';
import {getLanguageById} from '../helpers/language';

const LanguagePicker = ({currentLanguageId, setLanguageId, setUiLanguageId, currentUiLanguageId}) => {

  const changeLanguageId = (id) => {
    setUiLanguageId(id);
    setLanguageId(id === 3 ? 1 : id);
  };

  return (
    <div className="language-picker">
      <div
        className="current-language"
        // onClick={ () => { changeLanguageId(currentLanguageId === 1 ? 2 : 1); } }
      >
        {/*{ currentLanguageId === 1 ? <img src={ enIcon } alt={ '' } /> : <img src={ heIcon } alt={ '' } /> }*/}
        { getLanguageById(currentUiLanguageId).toUpperCase() }
      </div>
      <div className="language-list">
        { currentUiLanguageId !== 1 && (
            <div className="lang" onClick={ () => { changeLanguageId(1); } }>
                {/*<img src={ enIcon } alt={''}/>*/}EN
            </div>
        )}

          { currentUiLanguageId !== 2 && (
              <div className="lang" onClick={ () => { changeLanguageId(2); } }>
                  {/*<img src={ heIcon } alt={''}/>*/}HE
              </div>
          )}

          { currentUiLanguageId !== 3 && (
            <div className="lang" onClick={ () => { changeLanguageId(3); } }>
               {/*<img src={ heIcon } alt={''}/>*/}RU
            </div>
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    currentLanguageId,
      currentUiLanguageId
  } = state;

  return {
    currentLanguageId,
      currentUiLanguageId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLanguageId,
      setUiLanguageId
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LanguagePicker);
